import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import "../App.css";

const NotFound = () => {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", background: "#0b1d2b", color: "#ffffff" }}>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "6rem 2rem", textAlign: "center" }}>
        <span style={{ fontSize: "5rem", marginBottom: "1rem" }}>🧭</span>
        <h1 style={{ fontSize: "clamp(3rem, 6vw, 5rem)", fontWeight: "800", color: "#f59e0b", margin: "0 0 1rem 0" }}>404</h1>
        <h2 style={{ fontSize: "clamp(1.5rem, 3vw, 2rem)", fontWeight: "700", marginBottom: "1rem" }}>Page Off Course</h2>
        <p style={{ color: "#94a3b8", maxWidth: "500px", lineHeight: "1.6", marginBottom: "2rem" }}>
          The maritime route or page you are navigating toward does not exist or has been relocated.
        </p>
        <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", justifyContent: "center" }}>
          <Link to="/" style={{ padding: "0.85rem 1.8rem", background: "linear-gradient(135deg, #f59e0b, #d97706)", color: "#0b1d2b", borderRadius: "10px", fontWeight: "700", textDecoration: "none" }}>
            Return to Home
          </Link>
          <Link to="/services" style={{ padding: "0.85rem 1.8rem", background: "rgba(255,255,255,0.08)", color: "#ffffff", border: "1px solid rgba(255,255,255,0.2)", borderRadius: "10px", fontWeight: "600", textDecoration: "none" }}>
            View Our Services
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;
